export default [
  {
    path: '/nurse/index',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/index')
  },
  {
    path: '/nurse/choose',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/choose')
  },

  /**
   **** query
   * id 服务id
   * docId 医生id
   */
  {
    path: '/nurse/introduce',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/introduce')
  },
  /**
   * 预约服务-选择护理人、地址、时间
   **** query
   * deptId 科室id
   * deptName 科室名称
   */
  {
    path: '/nurse/order',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/order')
  },
  /**
   * 预约服务-上传资料
   **** query
   * deptId 科室id
   * deptName 科室名称
   */
  {
    path: '/nurse/order/remark',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/order-remark')
  },
  /**
   * 预约成功
   */
  {
    path: '/nurse/order/succeed',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/order-succeed')
  },
  /**
   * 网约订单列表
   */
  {
    path: '/nurse/list',
    meta: {
      title: '专科护理'
    },
    children:[
      {
        path: ':id',
        meta: {
          title: '专科护理'
        },
        component: () => import('../../src/pages/nurse/list-state.vue')
      }
    ],
    component: () => import('../pages/nurse/list')
  },

  /**
   * 网约订单详情
   */
  {
    path: '/nurse/detail',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/detail')
  },
  /**
   * 护士服务列表
   */
  {
    path: '/nurse/service',
    meta: {
      title: '专科护理'
    },
    component: () => import('../pages/nurse/service')
  },
]



// WEBPACK FOOTER //
// ./src/router/nurse.js